/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompteBancaireLightDto } from './CompteBancaireLightDto';
import {
    CompteBancaireLightDtoFromJSON,
    CompteBancaireLightDtoFromJSONTyped,
    CompteBancaireLightDtoToJSON,
    CompteBancaireLightDtoToJSONTyped,
} from './CompteBancaireLightDto';

/**
 * Assureur apériteur d'une garantie du tunnel.
 * @export
 * @interface AssureurPrincipalDto
 */
export interface AssureurPrincipalDto {
    /**
     * 
     * @type {string}
     * @memberof AssureurPrincipalDto
     */
    personneMoraleId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssureurPrincipalDto
     */
    designation?: string | null;
    /**
     * Code sous-nature de la compagnie (MUT, REA…), null pour un assureur classique.
     * @type {string}
     * @memberof AssureurPrincipalDto
     */
    sousNature?: string | null;
    /**
     * 
     * @type {CompteBancaireLightDto}
     * @memberof AssureurPrincipalDto
     */
    compteBancaire?: CompteBancaireLightDto;
    /**
     * 
     * @type {boolean}
     * @memberof AssureurPrincipalDto
     */
    aperition?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AssureurPrincipalDto
     */
    tauxQP?: number;
}

/**
 * Check if a given object implements the AssureurPrincipalDto interface.
 */
export function instanceOfAssureurPrincipalDto(value: object): value is AssureurPrincipalDto {
    return true;
}

export function AssureurPrincipalDtoFromJSON(json: any): AssureurPrincipalDto {
    return AssureurPrincipalDtoFromJSONTyped(json, false);
}

export function AssureurPrincipalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssureurPrincipalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'personneMoraleId': json['personneMoraleId'] == null ? undefined : json['personneMoraleId'],
        'designation': json['designation'] == null ? undefined : json['designation'],
        'sousNature': json['sousNature'] == null ? undefined : json['sousNature'],
        'compteBancaire': json['compteBancaire'] == null ? undefined : CompteBancaireLightDtoFromJSON(json['compteBancaire']),
        'aperition': json['aperition'] == null ? undefined : json['aperition'],
        'tauxQP': json['tauxQP'] == null ? undefined : json['tauxQP'],
    };
}

export function AssureurPrincipalDtoToJSON(json: any): AssureurPrincipalDto {
    return AssureurPrincipalDtoToJSONTyped(json, false);
}

export function AssureurPrincipalDtoToJSONTyped(value?: AssureurPrincipalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'personneMoraleId': value['personneMoraleId'],
        'designation': value['designation'],
        'sousNature': value['sousNature'],
        'compteBancaire': CompteBancaireLightDtoToJSON(value['compteBancaire']),
        'aperition': value['aperition'],
        'tauxQP': value['tauxQP'],
    };
}

